import { render } from "./NewDonorDeferralForm.vue?vue&type=template&id=e72073b6&scoped=true"
import script from "./NewDonorDeferralForm.vue?vue&type=script&lang=js"
export * from "./NewDonorDeferralForm.vue?vue&type=script&lang=js"

import "./NewDonorDeferralForm.vue?vue&type=style&index=0&id=e72073b6&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72073b6"]])

export default __exports__